import { gql } from '__generated__/gql';
import { ProfileSite } from '__generated__/graphql';
import { CompanyProfileListItem } from 'containers/NewProfile/newProfile.types';
import client from 'graphql/client';
import { fetchProfileGraphqlQuery } from './queries';
import { CompanyProfileSections } from './types';

const fetchProfileGraphql = (variables: { id: number }) =>
  client.query({
    query: fetchProfileGraphqlQuery,
    variables,
    fetchPolicy: 'network-only',
  });

export interface ProfileListItemResponse {
  data: {
    companyProfiles: Array<CompanyProfileListItem>;
  };
}

export const PROFILES_QUERY = gql(`
  query profiles {
    companyProfiles {
      id
      site
      companyName
      profileType
      published
      active
      link
      orderedProfileTypes {
        id
        profileType
        profileId
        site
      }
      subscriptionData {
        subscriptionId
        activeFromDate
        activeToDate
      }
    }
  }
`);

export const fetchProfiles = (): Promise<ProfileListItemResponse> => {
  return client.query({
    query: PROFILES_QUERY,
    fetchPolicy: 'network-only',
  }) as Promise<ProfileListItemResponse>;
};

export const mutationCreateProfile = (variables: { site: ProfileSite }) => {
  const mutation = gql(`
    mutation companyProfileCreate($site: ProfileSite!) {
      companyProfileCreate(site: $site) {
        id
      }
    }
  `);
  return client.mutate({
    mutation,
    variables,
  });
};

export const mutationCloneProfile = (variables: { id: any; toSite: ProfileSite }) => {
  if (!variables.id) {
    return Promise.reject();
  }
  return client.mutate({
    mutation: gql(`
    mutation cloneProfile($id: Int!, $toSite: ProfileSite!) {
      companyProfileClone(id: $id, toSite: $toSite) {
        id
      }
    }
  `),
    variables,
  });
};

export const fetchPreviewLinks = () => {
  const query = gql(`
    query companyProfilePreviewLinks {
      companyProfilePreviewLinks {
        link
        status
        id
      }
    }
  `);
  return client.query({
    query,
    fetchPolicy: 'network-only',
  }) as any;
};

type CloneProfileSectionResponse = {
  companyProfileSectionClone: {
    id: number;
  };
};

export const CLONE_PROFILE_SECTION = gql(`
    mutation cloneProfileSection(
      $fromProfileId: Int!
      $toProfileId: Int!
      $section: CompanyProfileSections
      $contentId: Int
    ) {
      companyProfileSectionClone(
        fromProfileId: $fromProfileId
        toProfileId: $toProfileId
        section: $section
        contentId: $contentId
      ) {
        id
      }
    }
  `);

export const mutationCloneProfileSection = (variables: {
  fromProfileId: number;
  toProfileId: number;
  section?: CompanyProfileSections;
  contentId?: number;
}) => {
  return client.mutate<CloneProfileSectionResponse>({
    mutation: CLONE_PROFILE_SECTION,
    variables,
  });
};

export { fetchProfileGraphql };
export default fetchProfileGraphql;
